const state = {
  sidebarCollapsed: false
}

const mutations = {
  SET_SIDEBAR_COLLAPSED (state, collapsed) {
    state.sidebarCollapsed = collapsed
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
